<template>
  <div class="contact-view">
    <v-container>
      <Contact/>
    </v-container>
  </div>
</template>
    
<script>
import Contact from '@/components/Contact/Contact.vue'
export default {
  components: {
    Contact
  },
};
</script>

<style lang="scss" scoped>
.contact-view {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding: 32px 0;
}

@media (max-width: 600px) {
  .contact-view {
    padding: 24px 0;
  }
}
</style>
    